import type { FaireThemeEntity } from "../../entity_types/theme";

export const pure_plant_based_essentials: FaireThemeEntity = {
  token: "pure-plant-based-essentials",
  type: "theme",
  name: "Pure Plant-Based Essentials",
  description: "Organic, essential-oil-infused body care and styling products for daily routines.",
  teaser: "Clean, plant-based body care that fits your non-toxic brand promise.",
  detail: "You prioritize natural ingredients, non-toxic, and vegan quality signals. These products -- from HAIR SPRITZ to Shower Gel -- are formulated with 100% pure therapeutic-grade essential oils and witch hazel.",
  bgColor: "#D4EEF0",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_huauuegq65",
    "p_r3dntyk8da",
    "p_ca8vg3knqx",
    "p_df9jt0hwsn",
    "p_89hzri8q58",
    "p_6bqyrkmnpc",
    "p_q9e66qz8ud",
    "p_19db5d85",
    "p_kpnqbrwtyw",
    "p_m5e6xpffhv",
    "p_s2ya4tycb5",
    "p_41i9adts",
    "p_8ih4abkp",
    "p_7ujrkwby4a",
    "p_ga86ayzj2b",
    "p_7tcncfve",
    "p_7ykdyk3bm3",
    "p_vqpd9fxugp",
    "p_g5ja78tprq",
    "p_yut37p2xwf",
    "p_85mhrm3stk",
    "p_fs4p74vzen",
    "p_btcfk94xtj",
    "p_54cafrksms",
    "p_jh55kwxbbu",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
